
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'RanchoLosAmigos',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RanchoLosAmigos.vue